module.exports = __webpack_public_path__ + "static/media/ico-dashboard.11b36484.svg";